import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import NutshellToGoogleCalendar from './icon-nutshell-to-google-calendar.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    if (validProps.width && validProps.height) {
        delete validProps.height;
    }

    return <NutshellToGoogleCalendar {...validProps} />;
}
SvgComponent.iconName = 'nutshellToGoogleCalendar';

export const NutshellToGoogleCalendarIcon = svgIconWrapper(SvgComponent);
